const DEAL_PATH_MARKERS = ["0-3", "deal", "deals"];

function isNumeric(value: string): boolean {
  return /^\d+$/.test(value);
}

export function extractDealId(input: string): string {
  const trimmed = input.trim();
  if (!trimmed || isNumeric(trimmed)) return trimmed;

  const segments = trimmed.split(/[/?#]/).filter(Boolean);

  const markerIndex = segments.findIndex((segment) =>
    DEAL_PATH_MARKERS.includes(segment),
  );
  const afterMarker = markerIndex >= 0 ? segments[markerIndex + 1] : undefined;
  if (afterMarker && isNumeric(afterMarker)) return afterMarker;

  const lastNumeric = [...segments].reverse().find(isNumeric);
  return lastNumeric ?? trimmed;
}
